// extracted by mini-css-extract-plugin
export default {"ResponsiveMedia":"ResponsiveMedia-module--ResponsiveMedia--lNCB2"};